const showMessage = (message, type, duration) => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent('app-message', { detail: { message, type, duration } }))
}

export { showMessage }


